import React from 'react';
import PropTypes from 'prop-types';

// import config
import { getSiteLogo } from '@cms/core/config/registration/mastheads';

// import utils
import { setNamespace } from '@utils/namespacing';

// import components
import Subheading from '../Typography/Subheading';
import Button from '../Buttons/Button';

import './_registrationBreach.scss';

const namespacify = setNamespace('et-core-regBreach');

const RegistrationBreach = ({ topText, bottomText, handleLogin, handleRegister, siteId }) => {
  const logo = getSiteLogo(siteId); // TODO: use the actual site logo instead of DummySVG
  return (
    <div className={namespacify('')}>
      {logo && <>{logo}</> }
      {topText && <Subheading customClasses={{ root: namespacify('_topText') }}>{topText}</Subheading>}
      <Button stretch handleClick={handleLogin} className={namespacify('_loginBtn')}>Log in</Button>
      {bottomText && <div className={namespacify('_bottomText')}>{bottomText}</div>}
      <div className={namespacify('_noAccountText')}>
          Don&apos;t have an account? <span onClick={handleRegister} className={namespacify('_signupLink')}>Sign up</span>
      </div>
    </div>
  );
};

RegistrationBreach.propTypes = {
  handleLogin: PropTypes.func.isRequired,
  handleRegister: PropTypes.func.isRequired,
  siteId: PropTypes.string.isRequired,
};

RegistrationBreach.defaultProps = {
  handleLogin: () => console.log('RegistrationBreach default handleLogin'),
  handleRegister: () => console.log('RegistrationBreach default handleRegister'),
  topText: 'Log in to continue reading.',
  bottomText: ''
};

export default RegistrationBreach;
